// Thumbnail scroll navigation - v7.15.0
  (function() {
    const wrapper = document.querySelector('.hp-pdp__gallery-thumbs-wrapper');
    if (!wrapper) return;
    
    const container = wrapper.querySelector('[data-thumbs-container]');
    const upBtn = wrapper.querySelector('[data-thumbs-nav="up"]');
    const downBtn = wrapper.querySelector('[data-thumbs-nav="down"]');
    const moreIndicator = wrapper.querySelector('[data-thumbs-more]');
    
    if (!container || !upBtn || !downBtn) return;
    
    const THUMB_HEIGHT = 82; // 72px thumb + 10px gap
    const VISIBLE_COUNT = 5;
    
    function updateNavState() {
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      const maxScroll = scrollHeight - clientHeight;
      
      // Show/hide up arrow
      upBtn.style.display = scrollTop > 10 ? 'flex' : 'none';
      
      // Show/hide down arrow and more indicator
      const atBottom = scrollTop >= maxScroll - 10;
      downBtn.style.display = atBottom ? 'none' : 'flex';
      if (moreIndicator) {
        const hiddenCount = Math.ceil((scrollHeight - scrollTop - clientHeight) / THUMB_HEIGHT);
        if (hiddenCount > 0 && !atBottom) {
          moreIndicator.textContent = '+' + hiddenCount;
          moreIndicator.style.display = 'flex';
        } else {
          moreIndicator.style.display = 'none';
        }
      }
    }
    
    upBtn.addEventListener('click', function() {
      container.scrollBy({ top: -THUMB_HEIGHT * 2, behavior: 'smooth' });
    });
    
    downBtn.addEventListener('click', function() {
      container.scrollBy({ top: THUMB_HEIGHT * 2, behavior: 'smooth' });
    });
    
    container.addEventListener('scroll', updateNavState);
    
    // Initial state
    setTimeout(updateNavState, 100);
    
    // Also scroll active thumbnail into view when clicking main gallery nav
    document.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        setTimeout(function() {
          const activeThumb = container.querySelector('.hp-pdp__thumb.active');
          if (activeThumb) {
            activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            setTimeout(updateNavState, 300);
          }
        }, 50);
      });
    });
  })();